import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { ButtonPrimary, ButtonSecondary } from "../buttonStyles/style";
import { H6, LoadingIcon, SmallBoldText } from "../textStyles/style";
import axios from "axios";
import { Alert } from "@mui/material";
import { Input } from "../Inputs";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

const InputContainer = styled.div`
  margin-top: 20px;
`;

export default function SendEmailModal({
  email,
  isOpen,
  setIsOpen,
  onText,
  id,
  appointment_id,
  coaching,
  expert,
}) {
  const history = useHistory();
  const [text, setText] = React.useState("");
  const [submitReady, setsubmitReady] = React.useState(false);
  const [object, setObject] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");
  const [submitLoader, setSubmitLoader] = React.useState(false);
  const [showSuccess, setShowSuccess] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const handleSubmit = () => {
    if (onText) {
      onText(text);
    }
  };

  const handleClose = () => {
    if (!submitLoader) {
      setIsOpen(false);
      setErrorMessage("");
      setShowSuccess(false);
      handleSubmit();
    }
  };

  const submitResponse = async () => {
    setLoading(true);
    setErrorMessage("");
    const TOKEN = localStorage.getItem("TOKEN");
    try {
      const resp = { access_token: TOKEN, id: id, response: text };
      console.log(resp);
      await axios.post(`${process.env.REACT_APP_CONTACT_RESPONDED}`, resp);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
      setErrorMessage("Probléme de Connexion");
    }
  };

  const submitHandler = () => {
    if (!submitLoader) {
      setErrorMessage("");
      setSubmitLoader(true);
      if (text.length < 4) {
        setErrorMessage("message too short");
        setSubmitLoader(false);
      } else if (object.length < 4) {
        setErrorMessage("objcet too short");
        setSubmitLoader(false);
      } else {
        const t = text.split("\n");
        const TOKEN = localStorage.getItem("TOKEN");
        console.log({
          email,
          object,
          text: t,
          access_token: TOKEN,
          coaching: coaching ? coaching : false,
          appointment_id: appointment_id ? appointment_id : "",
          expert: expert ? expert : false,
        });
        axios
          .post(process.env.REACT_APP_SEND_EMAIL, {
            email,
            object,
            text: t,
            access_token: TOKEN,
            coaching: coaching ? coaching : false,
            appointment_id: appointment_id ? appointment_id : "",
            expert: expert ? expert : false,
          })
          .then((res) => {
            setsubmitReady(true);
            setShowSuccess(true);
            setObject("");
            setText("");
            setSubmitLoader(false);
            if (coaching) {
              setTimeout(() => {
                history.go(0);
              }, 600);
            }
          })
          .catch((err) => {
            setSubmitLoader(false);
            console.log(err);
          });
      }
      if (id) {
        submitResponse();
      }
    }
  };

  return (
    <Dialog fullWidth maxWidth="md" open={isOpen}>
      <DialogContent>
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 30,
            marginBottom: 10,
          }}
        >
          <H6> send mail to {email}</H6>
        </div>

        {showSuccess && <Alert severity="success">Email has been send !</Alert>}
        <InputContainer>
          <Input
            placeholder="LISL UP - Object"
            value={object}
            onChange={(e) => setObject(e.target.value)}
          />
        </InputContainer>
        <InputContainer style={{ marginBottom: 5 }}>
          <Input
            multiline
            rows={8}
            placeholder="LISL UP - Mail "
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
        </InputContainer>
        <SmallBoldText
          style={{ textAlign: "center", fontSize: 12, color: "#c22222" }}
        >
          {errorMessage ? errorMessage : " - "}
        </SmallBoldText>
      </DialogContent>
      <DialogActions style={{ marginTop: -20, marginBottom: 15 }}>
        {!showSuccess && (
          <ButtonPrimary onClick={submitHandler}>
            {submitLoader ? <LoadingIcon color="#fff" /> : "Send mail"}
          </ButtonPrimary>
        )}
        <ButtonSecondary onClick={handleClose}>Close</ButtonSecondary>
      </DialogActions>
    </Dialog>
  );
}
